export enum SalesMonitorStatusEnum {
  IN_NEGOTIATION = 'IN_NEGOTIATION',
  CLOSED_WON = 'CLOSED_WON',
  CLOSED_LOST = 'CLOSED_LOST',
  NO_REPLY = 'NO_REPLY',
  DISQUALIFIED = 'DISQUALIFIED',
}
